import * as THREE from 'three'

export const wrappedYawDelta = (target: number, current: number) => Math.atan2(Math.sin(target - current), Math.cos(target - current))

/** World anchor with yaw hysteresis. No head pitch following, roll or frame jitter. */
export class FollowPanel {
  readonly position = new THREE.Vector3()
  readonly quaternion = new THREE.Quaternion()
  yaw = 0
  following = false
  private initialized = false
  private anchorHead = new THREE.Vector3()
  private target = new THREE.Vector3()
  private head = new THREE.Vector3()
  readonly distance = 1.05
  readonly elevation = 12 * Math.PI / 180

  reset() { this.initialized = false }

  update(head: THREE.Vector3Like, yaw: number, deltaSeconds: number) {
    this.head.copy(head)
    // A server teleport should not leave the readable panel several meters away.
    if (this.initialized && this.anchorHead.distanceTo(this.head) > 2) this.initialized = false
    if (!this.initialized) {
      this.yaw = yaw
      this.anchorHead.copy(head)
      this.targetPosition(head)
      this.position.copy(this.target)
      this.initialized = true
      this.following = false
    } else {
      const yawError = wrappedYawDelta(yaw, this.yaw)
      if (Math.abs(yawError) > 18 * Math.PI / 180 || this.anchorHead.distanceTo(this.head) > 0.28) this.following = true
      if (this.following) {
        const alpha = 1 - Math.exp(-Math.max(0, Math.min(deltaSeconds, 0.1)) / 0.22)
        this.yaw += yawError * alpha
        this.targetPosition(head)
        this.position.lerp(this.target, alpha)
        this.anchorHead.copy(head)
        if (Math.abs(wrappedYawDelta(yaw, this.yaw)) < 8 * Math.PI / 180 && this.position.distanceTo(this.target) < 0.012) this.following = false
      }
    }
    this.quaternion.setFromEuler(new THREE.Euler(this.elevation, this.yaw, 0, 'YXZ'))
    return this
  }

  private targetPosition(head: THREE.Vector3Like) {
    const horizontal = Math.cos(this.elevation) * this.distance
    this.target.set(head.x - Math.sin(this.yaw) * horizontal, head.y + Math.sin(this.elevation) * this.distance, head.z - Math.cos(this.yaw) * horizontal)
  }
}
